"use client";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../utils/api";

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const res = await api.post(
        "/users/login",
        { email, password },
        { withCredentials: true },
      );

      alert(res.data.message || "Login Success");
      navigate("/dashboard");
    } catch (err) {
      console.error("Axios error:", err);

      if (err.response) {
        alert(err.response.data.message);
      } else {
        alert("Network error");
      }
    }
  };

  return (
    <>
      <div className="h-screen flex">
        <div className="w-1/2 bg-gray-900 flex flex-col items-center justify-center text-white">
          <div className="mb-8">
            <img
              src="/bit.png"
              alt="Logo"
              width={250}
              height={250}
              className="rounded-full object-cover shadow-lg"
            />
          </div>
        </div>

        <div className="w-1/2 bg-white flex items-center text-black">
          <form onSubmit={handleLogin} className="my-auto mx-auto w-80">
            <h1 className="text-3xl font-bold mb-4">Welcome</h1>
            <p className="text-gray-500 mb-6">
              Please Enter Details to Sign in to Your Account
            </p>

            <input
              type="email"
              placeholder="Email"
              className="w-full border rounded px-3 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-gray-700"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <input
              type="password"
              placeholder="Password"
              className="w-full border rounded px-3 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-gray-700"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <button
              type="submit"
              className="w-full border text-black py-2 rounded hover:bg-gray-800 hover:text-white transition mb-4"
            >
              Log In
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
